import React from 'react';
import '../App.css';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className='hero-container'>
      <h1>SB Piliakalnis</h1>
      <p>...čia gyventi gera</p>
    </div>
  );
}

export default HeroSection;
